import { Grid } from "@material-ui/core";
import React from "react";
import "./gridControls.scss";
import sortUpIcon from "../../../../assets/images/sort-up.svg";
import sortDownIcon from "../../../../assets/images/sort-down.svg";
import sortIcon from "../../../../assets/images/sort.svg";
import SortIcon from "./SortIcon";

const SortIconEnum = {
  asc: sortUpIcon,
  desc: sortDownIcon,
  noSort: sortIcon,
};

const GridHeader = (props) => {
  const { handleSorting = (e) => {}, sortType = "", sortCol = "" } = props;
  return (
    <div className={props.className} style={{ marginBottom: "5px" }}>
      {props.items.map((i) => {
        return (
          <div style={{ display: "flex", fontSize: "12px" }}>
            <span
              style={{ display: "flex", cursor: "pointer" }}
              onClick={() => {
                handleSorting(i.colName, i?.key || null);
              }}
            >
              <b>{i.colName}</b>
              {/* {!!i?.sortable && (
                <div style={{ marginLeft: "5px", cursor: "pointer" }}>
                  {sortCol === i.colName ? (
                    <SortIcon sortType={sortType} />
                  ) : (
                    <SortIcon sortType={""} />
                  )}
                </div>
              )} */}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default GridHeader;
